
// primary blue, secondary dark blue, tertiary and menu pink, hightlight purple, sun orange

export const theme1 ={
    primary:'#0266c8',
    secondary:'#003063',
    tertiary:'#FFC2B0',
    menuBack:'#FFC2B0',
    background:'#fff',
    foreground:'#fff',
    highlight:'#b28bc0',
    wave:'#00a8ff',
    sun:'#FD9C36',
    header:'linear-gradient(#FFC2B0 ,#FEF7DA)',
    water:'linear-gradient(#00a8ff 10% ,#003062 80%)',
    arrow:'#003063'
}
// primary dark gray, secondary dark purple, teritiary neonish blue, moon white yellow
export const theme2 ={
    primary:'#121212',
    secondary:'#1E1E1E',
    tertiary:'#A9E2F4',
    menuBack:'#121212',
    background:'#fff',
    foreground:'#fff',
    highlight:'#b28bc0',
    sun:'#FEFCD7',
    header:'linear-gradient(#1F1C38,#1F1C38)',
    water:'linear-gradient(#121212,#121212)',
    wave:'#121212',
    arrow:'#fff'
}